<template>
  <div class="preview-product">
    <template v-if="selectedImage">
      <lightbox
        :image-url="selectedImage"
        @close="() => selectedImage = null"
      ></lightbox>
    </template>

    <div class="preview-product__image-wrapper">
      <template v-if="imageUrl">
        <img
          :src="imageUrl"
          alt="preview"
          class="preview-product__image"
          @click="() => selectedImage = imageUrl"
        />
      </template>
      <template v-else>
        <loader-icon></loader-icon>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, type Ref } from 'vue';

import pinia from '../../core/pinia';
import { useEditorStore } from '../../stores';

import LoaderIcon from './LoaderIcon.vue';
import Lightbox from './Lightbox.vue';

const selectedImage: Ref<string | null> = ref(null);

const editorStore = useEditorStore(pinia);
const imageUrl = computed(() => editorStore.getPreview);
</script>

<style scoped lang="scss">
.preview-product {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 13px;
  min-height: 416px;

  &__image-wrapper {
    max-width: 390px;
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

@media screen and (max-width: 768px) {
  .preview-product {
    min-height: 200px;    
  }
}
</style>